// src/components/installment-plan/installment-plan.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStylizedTextFragment on EGDSStylizedText {\n    text\n    theme\n    weight\n    decorative\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIconFragment on Icon {\n    description\n    id\n    size\n    theme\n    title\n    withBackground\n    spotLight\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSIllustrationFragment on Illustration {\n    description\n    link: url\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSMarkFragment on Mark {\n    description\n    id\n    url {\n      value\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment UIGraphicFragment on UIGraphic {\n    ...EGDSIconFragment\n    ...EGDSMarkFragment\n    ...EGDSIllustrationFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment AffirmContentDetailsFragment on AffirmContentDetails {\n    elementAttributes {\n      key\n      value\n    }\n    link {\n      analytics {\n        linkName\n        referrerId\n      }\n      label\n    }\n    text {\n      ...EGDSStylizedTextFragment\n    }\n    logo {\n      ...UIGraphicFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment AffirmDetailsFragment on AffirmDetails {\n    elementAttributes {\n      key\n      value\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment KlarnaDetailsFragment on KlarnaDetails {\n    elementAttributes {\n      key\n      value\n    }\n    scriptAttributes {\n      ...InstallmentPlanAttributeFragment\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n\n  fragment InstallmentPlanAttributeFragment on InstallmentPlanAttribute {\n    key\n    value\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  query InstallmentPlanQuery($context: ContextInput!, $multiItemSessionId: String, $amount: String) {\n    installmentPlan(context: $context, multiItemSessionId: $multiItemSessionId, installmentPriceAmount: $amount) {\n      installmentPlanDetails {\n        ...KlarnaDetailsFragment\n        ...AffirmDetailsFragment\n        ...AffirmContentDetailsFragment\n      }\n      impressionAnalytics {\n        linkName\n        referrerId\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
import React10, { useEffect, useState } from "react";
import { gql as gql9, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
// src/components/installment-plan/__private/__fragments/affirm-content-details.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { UitkMarkSize as UitkMarkSize2 } from "@egds/react-core/mark";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
// ../internal/src/components/egds-text/egds-stylized-text.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkText } from "uitk-react-text";
var fragment = gql(_templateObject());
var _obj;
var UitkTextThemeMap = (_obj = {}, _define_property(_obj, "LOYALTY" /* LOYALTY */ , "loyalty"), _define_property(_obj, "NEGATIVE" /* NEGATIVE */ , "negative"), _define_property(_obj, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj, "EMPHASIS" /* EMPHASIS */ , "emphasis"), _define_property(_obj, "PRIMARY" /* PRIMARY */ , "emphasis"), _define_property(_obj, "SECONDARY" /* SECONDARY */ , "default"), _define_property(_obj, "INVERSE" /* INVERSE */ , "inverse"), _obj);
var _obj1;
var UitkTextWeightMap = (_obj1 = {}, _define_property(_obj1, "BOLD" /* BOLD */ , "bold"), _define_property(_obj1, "MEDIUM" /* MEDIUM */ , "medium"), _define_property(_obj1, "REGULAR" /* REGULAR */ , "regular"), _obj1);
var EGDSStylizedText = function(props) {
    var data = props.data, textProps = props.textProps;
    var text = data.text, theme = data.theme, weight = data.weight, decorative = data.decorative;
    var textTheme = theme ? UitkTextThemeMap[theme] : void 0;
    var textWeight = weight ? UitkTextWeightMap[weight] : void 0;
    switch(decorative){
        case "LINE_THROUGH" /* LINE_THROUGH */ :
            var _textProps_theme;
            return /* @__PURE__ */ React.createElement("s", null, /* @__PURE__ */ React.createElement(UitkText, {
                size: textProps === null || textProps === void 0 ? void 0 : textProps.size,
                theme: (_textProps_theme = textProps === null || textProps === void 0 ? void 0 : textProps.theme) !== null && _textProps_theme !== void 0 ? _textProps_theme : textTheme,
                weight: textWeight,
                inline: textProps === null || textProps === void 0 ? void 0 : textProps.inline
            }, text));
        default:
            var _textProps_theme1;
            return /* @__PURE__ */ React.createElement(UitkText, {
                size: textProps === null || textProps === void 0 ? void 0 : textProps.size,
                theme: (_textProps_theme1 = textProps === null || textProps === void 0 ? void 0 : textProps.theme) !== null && _textProps_theme1 !== void 0 ? _textProps_theme1 : textTheme,
                weight: textWeight,
                inline: textProps === null || textProps === void 0 ? void 0 : textProps.inline
            }, text);
    }
};
EGDSStylizedText.fragment = fragment;
EGDSStylizedText.displayName = "EGDSStylizedText";
// ../internal/src/components/ui-graphic/ui-graphic.tsx
import React5 from "react";
import { gql as gql5 } from "@apollo/client";
// ../internal/src/components/egds-icon/egds-icon.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkIcon, UitkIconSize } from "@egds/react-core/icons";
var fragment2 = gql2(_templateObject1());
var _obj2;
var SPOTLIGHT_MAP = (_obj2 = {}, _define_property(_obj2, "INFO" /* INFO */ , "info"), _define_property(_obj2, "POSITIVE" /* POSITIVE */ , "positive"), _define_property(_obj2, "STANDARD" /* STANDARD */ , "standard"), _define_property(_obj2, "WARNING" /* WARNING */ , "warning"), _obj2);
var EGDSIcon = function(param) {
    var data = param.data, defaultIconSize = param.defaultIconSize, defaultIconTheme = param.defaultIconTheme, defaultIconSpotLight = param.defaultIconSpotLight;
    var description = data.description, id = data.id, size = data.size, title = data.title, theme = data.theme, withBackground = data.withBackground, spotLight = data.spotLight;
    var _ref;
    return /* @__PURE__ */ React2.createElement(UitkIcon, {
        description: description,
        id: id,
        name: id,
        size: size ? UitkIconSize[size] : defaultIconSize,
        title: title !== null && title !== void 0 ? title : void 0,
        theme: theme !== null && theme !== void 0 ? theme : defaultIconTheme,
        shadow: Boolean(withBackground),
        spotlight: (_ref = spotLight && SPOTLIGHT_MAP[spotLight] || defaultIconSpotLight) !== null && _ref !== void 0 ? _ref : void 0
    });
};
EGDSIcon.displayName = "EGDSIcon";
EGDSIcon.fragment = fragment2;
// ../internal/src/components/egds-illustration/egds-illustration.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { UitkIllustrations } from "uitk-react-illustrations";
var fragment3 = gql3(_templateObject2());
var EGDSIllustration = function(param) {
    var data = param.data;
    return /* @__PURE__ */ React3.createElement(UitkIllustrations, {
        alt: data.description,
        url: data.link
    });
};
EGDSIllustration.displayName = "EGDSIllustration";
EGDSIllustration.fragment = fragment3;
// ../internal/src/components/egds-mark/edgs-mark.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkMark } from "@egds/react-core/mark";
var fragment4 = gql4(_templateObject3());
var EGDSMark = function(param) {
    var data = param.data, size = param.size;
    var _data_url;
    if (!data.url && !data.id) {
        return null;
    }
    return /* @__PURE__ */ React4.createElement(UitkMark, {
        description: data.description,
        id: data.id,
        name: data.id,
        size: size,
        url: (_data_url = data.url) === null || _data_url === void 0 ? void 0 : _data_url.value
    });
};
EGDSMark.displayName = "EGDSMark";
EGDSMark.fragment = fragment4;
// ../internal/src/components/ui-graphic/ui-graphic.tsx
var fragment5 = gql5(_templateObject4(), EGDSIcon.fragment, EGDSMark.fragment, EGDSIllustration.fragment);
var UIGraphic = function(param) {
    var data = param.data, markProps = param.markProps, iconProps = param.iconProps;
    switch(data.__typename){
        case "Icon":
            return /* @__PURE__ */ React5.createElement(EGDSIcon, _object_spread({
                data: data
            }, iconProps));
        case "Mark":
            return /* @__PURE__ */ React5.createElement(EGDSMark, _object_spread({
                data: data
            }, markProps));
        case "Illustration":
            return /* @__PURE__ */ React5.createElement(EGDSIllustration, {
                data: data
            });
        default:
            return null;
    }
};
UIGraphic.displayName = "UIGraphic";
UIGraphic.fragment = fragment5;
// src/components/installment-plan/__private/__fragments/affirm-content-details.tsx
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLink } from "uitk-react-link";
import { UitkSpacing } from "uitk-react-spacing";
var fragment6 = gql6(_templateObject5(), EGDSStylizedText.fragment, UIGraphic.fragment);
var AffirmContentDetails = function(param) {
    var _param_data = param.data, elementAttributes = _param_data.elementAttributes, _param_data_link = _param_data.link, analytics = _param_data_link.analytics, label = _param_data_link.label, text = _param_data.text, logo = _param_data.logo;
    var track = useClickTracker();
    var genericAffirmElementAttributes = Object.fromEntries(elementAttributes.map(function(e) {
        return [
            e.key,
            e.value
        ];
    }));
    var handleClick = function() {
        track(analytics.referrerId, analytics.linkName);
    };
    return /* @__PURE__ */ React6.createElement(UitkLayoutFlex, {
        alignItems: "start",
        space: "one",
        justifyContent: "start",
        style: {
            blockSize: "12px"
        }
    }, /* @__PURE__ */ React6.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React6.createElement(EGDSStylizedText, {
        data: text,
        textProps: {
            size: 200
        }
    })), /* @__PURE__ */ React6.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React6.createElement(UIGraphic, {
        data: logo,
        markProps: {
            size: UitkMarkSize2.EXTRA_SMALL
        }
    })), /* @__PURE__ */ React6.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React6.createElement(UitkSpacing, {
        margin: {
            inlinestart: "one"
        }
    }, /* @__PURE__ */ React6.createElement(UitkLink, {
        inline: true,
        onClick: handleClick,
        size: "small"
    }, /* @__PURE__ */ React6.createElement("button", {
        type: "button"
    }, /* @__PURE__ */ React6.createElement("div", _object_spread({}, genericAffirmElementAttributes), label))))));
};
AffirmContentDetails.fragment = fragment6;
AffirmContentDetails.displayName = "AffirmContentDetails";
// src/components/installment-plan/__private/__fragments/affirm-details.tsx
import React7 from "react";
import { gql as gql7 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment7 = gql7(_templateObject6());
var AffirmDetails = function(param) {
    var _param_data = param.data, elementAttributes = _param_data.elementAttributes, analytics = _param_data.analytics;
    var track = useClickTracker2();
    var pricedAffirmElementAttributes = Object.fromEntries(elementAttributes.map(function(e) {
        return [
            e.key,
            e.value
        ];
    }));
    var handleClick = function() {
        track(analytics.referrerId, analytics.linkName);
    };
    return /* @__PURE__ */ React7.createElement(UitkText2, {
        size: 100,
        weight: "regular"
    }, /* @__PURE__ */ React7.createElement("div", _object_spread_props(_object_spread({}, pricedAffirmElementAttributes), {
        onClick: handleClick,
        "aria-hidden": "true",
        role: "link"
    })));
};
AffirmDetails.fragment = fragment7;
AffirmDetails.displayName = "AffirmDetails";
// src/components/installment-plan/__private/__fragments/klarna-details.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
var fragment8 = gql8(_templateObject7());
var KlarnaDetails = function(param) {
    var _param_data = param.data, elementAttributes = _param_data.elementAttributes, analytics = _param_data.analytics;
    var track = useClickTracker3();
    var klarnaElementAttributes = Object.fromEntries(elementAttributes.map(function(e) {
        return [
            e.key,
            e.value
        ];
    }));
    var handleClick = function() {
        track(analytics.referrerId, analytics.linkName);
    };
    return /* @__PURE__ */ React8.createElement("klarna-placement", _object_spread_props(_object_spread({}, klarnaElementAttributes), {
        onClick: handleClick
    }));
};
KlarnaDetails.fragment = fragment8;
KlarnaDetails.displayName = "KlarnaDetails";
// src/components/installment-plan/affirm.ts
var createAffirmScript = function(scriptId) {
    return '_affirm_config = {\n    public_api_key:  "QIMSOFSMVEEZ1CXA",\n    script:          "https://cdn1.affirm.com/js/v2/affirm.js",\n    id: "'.concat(scriptId, '"\n  };\n(function(l,g,m,e,a,f,b,p){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,"set");d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b="set add save post open empty reset on off trigger ready setProduct".split(" ");a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=["get","token","url","items"];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];h.id=g[p];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,_affirm_config,"affirm","checkout","ui","script","ready", "id");');
};
var loadAffirmScript = function(onload) {
    var flag = document.getElementById("affirm-script");
    if (!flag) {
        var affirmExternalScriptId = "affirm-external-script";
        var scriptElement = document.createElement("script");
        scriptElement.type = "text/javascript";
        var externalScript = document.createTextNode(createAffirmScript(affirmExternalScriptId));
        scriptElement.appendChild(externalScript);
        document.head.appendChild(scriptElement);
        scriptElement.setAttribute("data-stid", "affirm-script");
        scriptElement.setAttribute("id", "affirm-script");
        var affirmScript = document.getElementById(affirmExternalScriptId);
        if (affirmScript) {
            affirmScript.onload = function() {
                onload();
            };
        }
    } else {
        onload();
    }
};
// src/components/installment-plan/installment-plan-placeholder.tsx
import React9 from "react";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
var InstallmentPlanPlaceholder = function(param) {
    var legalTextAlignment = param.legalTextAlignment, secondPlaceholderRequired = param.secondPlaceholderRequired, margin = param.margin;
    if (secondPlaceholderRequired) {
        return /* @__PURE__ */ React9.createElement(UitkLayoutGrid, {
            space: "half",
            justifyItems: legalTextAlignment !== null && legalTextAlignment !== void 0 ? legalTextAlignment : "start"
        }, /* @__PURE__ */ React9.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React9.createElement(UitkSpacing2, {
            margin: margin !== null && margin !== void 0 ? margin : {
                blockstart: "one",
                blockend: "half"
            }
        }, /* @__PURE__ */ React9.createElement(UitkLineSkeleton, null))), /* @__PURE__ */ React9.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React9.createElement(UitkLineSkeleton, {
            type: "secondary"
        })));
    }
    return /* @__PURE__ */ React9.createElement(UitkSpacing2, {
        margin: margin !== null && margin !== void 0 ? margin : {
            blockstart: "one",
            blockend: "half"
        }
    }, /* @__PURE__ */ React9.createElement(UitkLineSkeleton, null));
};
// src/components/installment-plan/klarna.ts
var loadKlarnaScript = function(installmentPlan, onload) {
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.onload = onload;
    document.head.appendChild(script);
    script.src = "https://osm.klarnaservices.com/lib.js";
    script.async = true;
    installmentPlan.map(function(param) {
        var key = param.key, value = param.value;
        return script.setAttribute(key, value);
    });
    script.crossOrigin = "anonymous";
};
// src/components/installment-plan/installment-plan.tsx
var __Query = gql9(_templateObject8(), KlarnaDetails.fragment, AffirmDetails.fragment, AffirmContentDetails.fragment);
var InstallmentPlan = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, margin = props.margin, placeholderMargin = props.placeholderMargin, alignment = props.alignment, legalText = props.legalText, minWidth = props.minWidth;
    var context = useBexApi().context;
    var _useState = _sliced_to_array(useState(true), 2), loadingScript = _useState[0], setLoadingScript = _useState[1];
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    var installmentPlanData = data === null || data === void 0 ? void 0 : data.installmentPlan;
    var onScriptLoad = function() {
        setLoadingScript(false);
    };
    useEffect(function() {
        var affirm = window.affirm, Klarna = window.Klarna;
        if ((installmentPlanData === null || installmentPlanData === void 0 ? void 0 : installmentPlanData.installmentPlanDetails.__typename) === "KlarnaDetails") {
            loadKlarnaScript(installmentPlanData.installmentPlanDetails.scriptAttributes, onScriptLoad);
            Klarna === null || Klarna === void 0 ? void 0 : Klarna.OnsiteMessaging.refresh();
        } else if ((installmentPlanData === null || installmentPlanData === void 0 ? void 0 : installmentPlanData.installmentPlanDetails.__typename) === "AffirmContentDetails" || (installmentPlanData === null || installmentPlanData === void 0 ? void 0 : installmentPlanData.installmentPlanDetails.__typename) === "AffirmDetails") {
            loadAffirmScript(onScriptLoad);
            affirm === null || affirm === void 0 ? void 0 : affirm.ui.ready(function() {
                setLoadingScript(false);
                affirm.ui.refresh();
            });
        } else {
            setLoadingScript(false);
        }
    }, [
        installmentPlanData
    ]);
    if (loading || loadingScript) {
        return /* @__PURE__ */ React10.createElement(InstallmentPlanPlaceholder, {
            legalTextAlignment: alignment,
            secondPlaceholderRequired: legalText,
            margin: placeholderMargin
        });
    }
    if (error || !installmentPlanData) {
        return null;
    }
    var installmentPlanDetails = installmentPlanData.installmentPlanDetails;
    var getInstallmentPlan = function() {
        switch(installmentPlanDetails.__typename){
            case "AffirmContentDetails":
                return /* @__PURE__ */ React10.createElement(AffirmContentDetails, {
                    data: installmentPlanDetails
                });
            case "AffirmDetails":
                return /* @__PURE__ */ React10.createElement(AffirmDetails, {
                    data: installmentPlanDetails
                });
            case "KlarnaDetails":
                return /* @__PURE__ */ React10.createElement(KlarnaDetails, {
                    data: installmentPlanDetails
                });
            default:
                return null;
        }
    };
    return /* @__PURE__ */ React10.createElement(UitkSpacing3, {
        margin: margin
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlex2, {
        direction: "column"
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem2, {
        minWidth: minWidth !== null && minWidth !== void 0 ? minWidth : "4x__half"
    }, /* @__PURE__ */ React10.createElement(IntersectionTracker, {
        trackOnce: true,
        referrerId: installmentPlanData.impressionAnalytics.referrerId,
        linkName: installmentPlanData.impressionAnalytics.linkName
    }, /* @__PURE__ */ React10.createElement("div", null, getInstallmentPlan())))));
};
InstallmentPlan.displayName = "sharedui-InstallmentPlan";
export { InstallmentPlan }; /* istanbul ignore next -- @preserve */ 
//# sourceMappingURL=index.js.map